import { boolean, defineAction, number, object, string } from '~/prix'
import synchronizeAppSebraeAction from './synchronizeAppSebrae.action.json'

const synchronizeAppSebraeDefinition = defineAction({
  ...synchronizeAppSebraeAction,
  input: object({
    id: string().isOptional(),
    year: number().isOptional(),
    limit: number().isOptional(),
    force: boolean().isOptional(),
    verbose: boolean().isOptional(),
    onlyMissing: boolean().isOptional(),
    skipInternalGeocoding: boolean().isOptional(),
    dryRun: boolean().isOptional(),
  }),
  output: object({
    success: boolean(),
    queued: boolean(),
    dryRun: boolean(),
    total: number(),
    selected: number(),
    processed: number(),
    warnings: number(),
    errorCount: number(),
  }),
})

export default synchronizeAppSebraeDefinition
